import React from 'react';
import { Instagram, Facebook, Youtube, Linkedin } from 'lucide-react';

const destinations = [
  'Wedding Hotels in Jaipur',
  'Wedding Hotels in Goa',
  'Wedding Hotels in Udaipur',
  'Wedding Hotels in Jaisalmer',
  'Destination Wedding in Rajasthan',
];

const links = ['FAQ’s', 'Terms of Use', 'Privacy Policy', 'Cookie Policy'];

const socials = [
  { name: 'Instagram', icon: Instagram },
  { name: 'Facebook', icon: Facebook },
  { name: 'YouTube', icon: Youtube },
  { name: 'LinkedIn', icon: Linkedin }
];

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-[#395958] to-[#2a4342] text-white" id="contact">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div>
            <img src="/ypd.png" alt="YPD Weddings Worldwide" className="h-14 md:h-16 mb-6" />
            <p className="text-sm text-white/70 leading-relaxed">
              Add: 3rd floor, Vraj Group, Simran Center,<br />Parsi Panchayat Road, Andheri East, Mumbai - 63
            </p>
            <p className="text-sm text-white/70 mt-4">
              Email: info.ypdweddings@gmail.com<br />Phone: +91-9004304730
            </p>
          </div>

          <div>
            <h5 className="text-xs uppercase tracking-[0.3em] text-[#F1D291] mb-4">Destinations</h5>
            <ul className="space-y-3 text-sm text-white">
              {destinations.map((dest) => (
                <li key={dest}>{dest}</li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="text-xs uppercase tracking-[0.3em] text-[#F1D291] mb-4">Connect</h5>
            <div className="space-y-3 text-sm text-[#F1D291]">
              {socials.map((social) => {
                const IconComponent = social.icon;
                return (
                  <button
                      key={social.name}
                      className="flex items-center gap-3 w-full text-left border border-white/20 px-4 py-2 text-white hover:text-[#F1D291] hover:bg-white/10 transition-colors"
                    >
                    <IconComponent size={16} />
                    {social.name}
                  </button>
                );
              })}
            </div>
          </div>

          <div>
            <h5 className="text-xs uppercase tracking-[0.3em] text-[#F1D291] mb-4">Join Our Newsletter Family</h5>
            <input
              type="email"
              placeholder="Enter Email Address"
              className="w-full bg-transparent border border-white/20 px-4 py-3 text-sm text-white placeholder-white/50 focus:outline-none"
            />
            <button className="mt-4 px-6 py-3 border border-white text-white uppercase tracking-[0.3em] text-[10px] w-full">
              Subscribe Now
            </button>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-[#F1D291] uppercase tracking-[0.3em]">
          <div className="flex flex-wrap justify-center gap-4">
            {links.map((link) => (
              <span key={link}>{link}</span>
            ))}
          </div>
          <p>© 2025 ypdweddings All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
